import { FaSpinner } from "react-icons/fa";

export default function LoadingIndicator() {
  return (
    <>
      <div className="align-center fixed z-50 flex h-screen w-screen items-center justify-center bg-gray-600 opacity-70"></div>
      <div className="fixed left-[50%] top-[50%] z-50 flex h-[150px] w-[150px] -translate-x-2/4 -translate-y-2/4 items-center justify-center rounded-full bg-light-header-color dark:bg-gray-700">
        <FaSpinner className="loader animate-spin text-gray-500 dark:text-gray-500" />
        {/* <img src={Herc} alt="Herc's Head" className="loader_herc_head" /> */}
      </div>
    </>
  );
}
